import index from './'
import MetaCentroCusto from './MetaCentroCusto'
import Resposta from './Resposta'
import Processo from './Processo'
import competenciaArvore from './Arvore'

export default [
  {
    props: true,
    path: 'competencia',
    name: 'competencia.index',
    component: index,
    meta: {requiresAuth: true, label: 'Competência'}
  },
  {
    props: true,
    path: 'competencia/arvore',
    name: 'competencia.arvore',
    component: competenciaArvore,
    meta: {requiresAuth: true, label: 'Competência Árvore'}
  },
  {
    props: true,
    path: 'competencia/meta',
    name: 'competencia.meta',
    component: MetaCentroCusto,
    meta: {requiresAuth: true, label: 'Competência Meta'}
  },
  {
    props: true,
    path: 'competencia/resposta',
    name: 'competencia.resposta',
    component: Resposta,
    meta: {requiresAuth: true, label: 'Competência Resposta'}
  },
  {
    props: true,
    path: 'competencia/processo',
    name: 'competencia.processo',
    component: Processo,
    meta: {requiresAuth: true, label: 'Competência Processo'}
  }
]



// WEBPACK FOOTER //
// ./src/features/Competencia/routes.js